import React from "react"
import {
    Grid,
    Table,
    TableBandHeader,
    TableHeaderRow,
    TableSummaryRow,
} from "@devexpress/dx-react-grid-material-ui"
import {
    IntegratedSummary,
    SummaryState
} from "@devexpress/dx-react-grid"
import {
    summaryCalculator,
    TableSummaryRowCell,
    BandCell,
    SummaryCell,
    HeaderRowCell,
    TableCell
} from "./Monitoring"

export const TargetsTable = (props) => {
    const { data, tableData } = props

    return (
        <Grid
            rows={data}
            columns={tableData?.targetsColumns}
        >
            <SummaryState
                totalItems={tableData?.totalSummaryItems}
            />
            <IntegratedSummary
                calculator={summaryCalculator}
            />
            <Table
                columnExtensions={tableData?.tableColumnExtensions}
                cellComponent={TableCell({})}
            />
            <TableHeaderRow
                cellComponent={HeaderRowCell}
            />
            <TableBandHeader
                columnBands={tableData?.columnBands}
                cellComponent={BandCell()}
            />
            <TableSummaryRow
                itemComponent={TableSummaryRowCell}
                totalCellComponent={SummaryCell({})}
            />
        </Grid>
    )
}

export default TargetsTable